__turbopack_context__.v({
  "active": "CustomDropDownItem-module__qwsrIG__active",
  "labelWrapper": "CustomDropDownItem-module__qwsrIG__labelWrapper",
});
